import { formatInTimeZone } from 'date-fns-tz'
import { format } from 'date-fns'

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export function formatDateWithTimezonOffset (date) {
  if (!date) {
    return null
  }
  return new Date(date.valueOf() + date.getTimezoneOffset() * 60 * 1000)
}

export const formatUTC = (timestamp) => formatInTimeZone(timestamp, 'UTC', 'MMM d, yyyy')

export const formatWrapped = (date, dateFormat) => {
  if (!date) {
    return ''
  }

  try {
    return format(date, dateFormat)
  } catch (error) {
    return 'Invalid date'
  }
}

export const isExpired = (date) => {
  const currentDate = new Date().getTime()

  const comparedDate = new Date(date).getTime()

  return currentDate > comparedDate
}
